define(["require", "exports", "tslib", "@material-ui/core/colors", "@material-ui/core/styles", "mobx", "../model/services", "./Events"], function (require, exports, tslib_1, colors_1, styles_1, mobx_1, services_1, Events_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.UIStore = exports.boxShadow = exports.boxShadowDark = exports.blueLight = exports.blueDark = void 0;
    exports.blueDark = "#1ab3e3";
    exports.blueLight = "#4bc7f4";
    exports.boxShadowDark = "0px 3px 1px -2px rgb(0 0 0 / 15%), 0px 2px 2px 0px rgb(0 0 0 / 15%), 0px 1px 5px 0px rgb(0 0 0 / 10%)";
    exports.boxShadow = "0px 1px 0px -1px rgb(0 0 0 / 10%), 0px 1px 1px 0px rgb(0 0 0 / 10%), 0px 1px 2px 0px rgb(0 0 0 / 0%)";
    class UIStore {
        get IsDesktop() {
            return !this.IsTablet && !this.IsMobile;
        }
        get Theme() {
            return (0, styles_1.createTheme)({
                typography: {
                    fontFamily: ['Roboto', 'Arial', 'sans-serif'].join(','),
                },
                palette: {
                    primary: {
                        main: "#1AB3E3"
                    },
                    secondary: {
                        dark: colors_1.grey["500"],
                        light: colors_1.grey["100"],
                        main: colors_1.pink.A400
                    }
                },
                overrides: Object.assign(Object.assign({ MuiTypography: {
                        root: {
                            fontSize: "inherit"
                        },
                        body1: {
                            fontSize: "inherit"
                        }
                    }, MuiInputBase: {
                        root: {
                            fontSize: "inherit"
                        }
                    }, MuiInput: {
                        root: {
                            padding: "10px"
                        },
                        underline: {
                            '&::before': {
                                borderBottom: "none"
                            },
                            '&.Mui-disabled': {
                                '&::before': {
                                    borderBottom: "none"
                                }
                            },
                            '&:hover:not(.Mui-disabled):before': {
                                borderBottom: "none"
                            },
                        },
                    } }, {
                    MuiAutocomplete: {
                        inputRoot: {
                            paddingBottom: "10px !important",
                        }
                    }
                }), { MuiAppBar: {
                        root: {
                            height: 50
                        }
                    }, MuiDrawer: {
                        paperAnchorDockedLeft: {
                            borderRight: 0,
                            boxShadow: exports.boxShadow
                        }
                    }, MuiButton: {
                        containedPrimary: {
                            color: "#fff",
                        },
                        contained: {
                            boxShadow: exports.boxShadow,
                            backgroundColor: "#f5f5f5",
                            '&.hover': {
                                boxShadow: exports.boxShadowDark,
                            },
                        },
                    }, MuiDialog: {
                        paperWidthSm: {
                            maxWidth: "inherit"
                        },
                        paperWidthMd: {
                            maxWidth: "inherit"
                        }
                    }, MuiDialogContent: {
                        root: {
                            width: "inherit"
                        }
                    }, MuiTabs: {
                        root: {
                            marginBottom: "10px",
                            backgroundColor: "#f5f5f5",
                        },
                        indicator: {
                            backgroundColor: exports.blueLight
                        },
                        scrollButtons: {
                            '&.Mui-disabled': {
                                display: "none"
                            }
                        }
                    }, MuiTab: {
                        root: {
                            minWidth: "90px",
                            "@media (min-width: 600px)": {
                                minWidth: "90px"
                            }
                        }
                    }, MuiTableCell: {
                        root: {
                            borderRight: '1px solid rgba(200, 200, 200, 0.2)',
                            borderBottom: 'none',
                            wordWrap: "break-word"
                        }
                    }, MuiTablePagination: {
                        root: {
                            padding: 0,
                            border: "none"
                        }
                    }, MuiListItemText: {
                        multiline: {
                            textOverflow: 'clip',
                            overflowWrap: 'break-word'
                        }
                    } }),
            });
        }
        constructor(storeManager) {
            Object.defineProperty(this, "storeManager", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsLocked", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "IsMenuOpen", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "IsMapOpen", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "IsTablet", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "IsMobile", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "lhsPanelDimensions", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: {
                    width: 800
                }
            });
            Object.defineProperty(this, "IsRedlineToolActive", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "lockExceptions", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: [
                    "keepAlive",
                    "findApplicantsByName",
                    "getConfiguration"
                ]
            });
            Object.defineProperty(this, "toggleMenu", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    this.IsMenuOpen = !this.IsMenuOpen;
                }
            });
            Object.defineProperty(this, "toggleMap", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    this.IsMapOpen = !this.IsMapOpen;
                }
            });
            (0, mobx_1.makeObservable)(this);
            this.storeManager = storeManager;
            const tabletBp = window.matchMedia("(max-width: 768px)");
            this.onMobileBreakPoint(tabletBp);
            window
                .matchMedia("(max-width: 768px)")
                .addListener(this.onTabletBreakPoint.bind(this));
            const mobileBp = window.matchMedia("(max-width: 414px)");
            this.onMobileBreakPoint(mobileBp);
            window
                .matchMedia("(max-width: 414px)")
                .addListener(this.onMobileBreakPoint.bind(this));
            this.IsMenuOpen = this.IsDesktop;
            this.IsMapOpen = this.IsDesktop;
            services_1.EventManager.Instance.on(Events_1.SERVICE_REQUEST_INIT, (...args) => {
                if (this.lockExceptions.indexOf(args[0]) == -1) {
                    this.IsLocked = true;
                }
            });
            services_1.EventManager.Instance.on(Events_1.SERVICE_REQUEST_SUCCESS, (...args) => {
                if (this.IsLocked) {
                    this.IsLocked = false;
                }
            });
            services_1.EventManager.Instance.on(Events_1.SERVICE_REQUEST_ERROR, (...args) => {
                if (this.IsLocked) {
                    this.IsLocked = false;
                }
            });
            services_1.EventManager.Instance.on(Events_1.ROUTE_PUSH_EVENT, (path) => {
                if (this.IsMapOpen) {
                    this.IsMapOpen = false;
                }
            });
            services_1.EventManager.Instance.on(Events_1.CONFIG_READY_EVENT, (appConfig) => {
            });
            services_1.EventManager.Instance.on(Events_1.REDLINES_CHANGE_EVENT, (active) => {
                this.IsRedlineToolActive = active;
            });
        }
        onTabletBreakPoint(x) {
            this.IsTablet = x.matches;
        }
        onMobileBreakPoint(x) {
            this.IsMobile = x.matches;
        }
    }
    exports.UIStore = UIStore;
    tslib_1.__decorate([
        mobx_1.computed
    ], UIStore.prototype, "IsDesktop", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], UIStore.prototype, "IsLocked", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], UIStore.prototype, "IsMenuOpen", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], UIStore.prototype, "IsMapOpen", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], UIStore.prototype, "IsTablet", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], UIStore.prototype, "IsMobile", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], UIStore.prototype, "lhsPanelDimensions", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], UIStore.prototype, "IsRedlineToolActive", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], UIStore.prototype, "toggleMenu", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], UIStore.prototype, "toggleMap", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], UIStore.prototype, "onTabletBreakPoint", null);
    tslib_1.__decorate([
        mobx_1.action
    ], UIStore.prototype, "onMobileBreakPoint", null);
});
